import {createGrid} from "../../helpers/grids/grids";
import {loading, stopLoading} from "../../helpers/loading";
import createElement from "../../helpers/createElement";
import {createCellRenderer, createDoubleClickHandler,} from "../../helpers/grids/helpers";
import Axios from "axios";
import {handleAjaxSuccess, swalConfirm} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initVoeThirdPartyCompanyIndex() {
	createGrid('.third-party-companies-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Name',
					sortable: true,
				},
				{
					field: "email",
					headerName: 'Email',
					sortable: true,
				},
				{
					field: "phone",
					headerName: 'Phone',
					sortable: true,
				},
				{
					field: "fax",
					headerName: 'Fax',
					sortable: true,
				},
				{
					field: "public_id",
					headerName: '',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const edit_url = params.data.edit_url;
						const detail_url = params.data.detail_url;
						const buttons = createElement(`
							<div class="buttons">
								<a class="btn btn-primary btn-sm" href="${detail_url}">
                                    <i class="fa-solid fa-eye"></i>
                                    View
								</a>
                                <a
                                	class="btn btn-primary btn-sm ${!edit_url ? 'disabled' : ''}" href="${edit_url}"
                                >
                                    <i class="fa-solid fa-file-import"></i>
                                    Edit
								</a>
								<button type="button" class="btn btn-danger btn-sm remove-third-party-company-button">
                                    <i class="fa-solid fa-trash"></i>
                                    Remove
                                </button>
                            </div>
						`);

						buttons.querySelector('.remove-third-party-company-button')
							.addEventListener('click', () => {
								removeCompany(params.data);
							})

						return buttons;
					})
				},
			],

			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				if (data.edit_url) {
					loading();
					window.location.href = data.edit_url
				}
			}),

			rowClass: 'cursor-pointer',
			paginationPageSize: 20,
			_rowName: 'Third Party Companies',
		},
		window['routes/admin.third-party-companies.grid']
	);

	function removeCompany(account) {
		swalConfirm({
			title: 'Are you sure you want to delete this Company?'
		}).then(result => {
			if (result.isConfirmed) {
				loading();

				// noinspection JSUnresolvedVariable
				Axios.post(account.remove_url, {})
					.then(handleAjaxSuccess)
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}
}

export {initVoeThirdPartyCompanyIndex}
